import { isAndroid, isIOS, isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';

import Store from 'lib/Store/withLocalStorage';
import { useController } from 'pages/Meetings/hooks/useController';
import theme from 'styles/themes/default';

import { useWebp } from 'hooks/useWebp';

import config from 'config/general';

import Button from 'components/atom/Form/Button';
import Text from 'components/atom/Text/styles';
import HeaderContent from 'components/molecule/HeaderContent';
import TabsNavigation from 'components/molecule/TabsNavigation';

import Appointments from './components/Appointments';
import Invitations from './components/Invitations';
import SearchWrapper from './components/Search';
import {
  AdContent,
  Container,
  Content,
  DesktopADContent,
  MainContent,
  MobileADContent,
} from './styles';

const tabsComponents = ['appointments', 'invitations', 'search'] as const;

const componentsMeetings = {
  appointments: <Appointments />,
  invitations: <Invitations />,
  search: <SearchWrapper />,
};
const authStore = Store(`${config.localStorageKey}-auth`);

const Schedule: React.FC = () => {
  const { t } = useTranslation();

  const { tab, setTab } = useController();

  const optionsTab = [
    `${t('meetings:navigation.appointments')}`,
    `${t('meetings:navigation.invitations')}`,
    `${t('meetings:navigation.search')}`,
  ];

  const isApp = authStore.getItem('isApp') === 'true';

  const redirectToStore = (): void => {
    if (isMobile) {
      if (isAndroid) {
        window.location.href = config.android.downloadURL;
      } else if (isIOS) {
        window.location.href = config.ios.downloadURL;
      }
    } else {
      window.open(config.android.downloadURL, '_blank');
    }
  };

  const webp = useWebp();

  const backgroundImg = webp ? `/images/meetings/webp/bg-ad.webp` : `/images/meetings/bg-ad.jpg`;

  return (
    <Container>
      {isApp && <HeaderContent title={t('meetings:title')} />}

      <TabsNavigation options={optionsTab} setTab={setTab} tab={tab} />

      <Content>
        <MainContent>{componentsMeetings[tabsComponents[tab]]}</MainContent>

        {!isApp && (
          <AdContent>
            <button type="button" onClick={() => redirectToStore()}>
              <DesktopADContent url={backgroundImg}>
                {/* <Text
                color={theme.colors.white}
                size={22}
                weight="900"
                lineHeight={28}
                padding="0 0 20px"
              >
                {t('meetings:sloganApp')}
              </Text>

              <ContainerButtons>
                <ButtonsStore
                  onClick={() => {
                    window.open(config.ios.downloadURL, '_blank');
                  }}
                >
                  <Image
                    src="/images/meetings/apple-store.png"
                    srcWebp="/images/meetings/webp/apple-store.webp"
                    alt="Play Store"
                    height={37}
                    width={126}
                  />
                </ButtonsStore>

                <ButtonsStore
                  onClick={() => {
                    window.open(config.android.downloadURL, '_blank');
                  }}
                >
                  <Image
                    src="/images/meetings/google-play.png"
                    srcWebp="/images/meetings/webp/google-play.webp"
                    alt="Apple Store"
                    height={37}
                    width={113}
                  />
                </ButtonsStore>
              </ContainerButtons>

              <Image
                className="desktop-image"
                src="/images/meetings/phone-app.png"
                srcWebp="/images/meetings/webp/phone-app.webp"
                alt="AD"
                height={316}
              /> */}
              </DesktopADContent>
            </button>

            <MobileADContent>
              {/* <Image
                id="mobile-image"
                className="mobile-image"
                src="/images/meetings/Phone.png"
                srcWebp="/images/meetings/webp/Phone.webp"
                alt="Phone"
                width={272}
              /> */}

              <Text
                color={theme.colors.white}
                size={15}
                weight="bold"
                lineHeight={22}
                textAlign="center"
              >
                {t('meetings:sloganApp')}
              </Text>

              <Button
                text={t('meetings:actions.downloadApp')}
                disabledUppercase
                theme="blue03"
                isSmall
                onClick={() => redirectToStore()}
              />
            </MobileADContent>
          </AdContent>
        )}
      </Content>
    </Container>
  );
};

export default Schedule;
